import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { Order } from "@/types/types";

import { AdminState } from "@/types/admin";

import { adminApi } from "./admin.api";

const initialState: AdminState = {
	users: [],
	sortingUsers: {
		sortBy: "createdAt",
		sortOrder: Order.DESC,
	},
	meta: {
		page: 1,
		limit: 15,
		itemCount: 15,
		pageCount: 1,
		hasPreviousPage: false,
		hasNextPage: false,
	},
	senders: [],
};

export const adminSlice = createSlice({
	name: "admin",
	initialState,
	reducers: {
		setUsersSorting: (state, { payload }) => {
			if (
				state.sortingUsers.sortOrder === Order.DESC &&
				payload.sortOrder === Order.ASC &&
				payload.sortBy === state.sortingUsers.sortBy
			) {
				payload.sortBy = initialState.sortingUsers.sortBy;
				payload.sortOrder = initialState.sortingUsers.sortOrder;
			}

			state.sortingUsers = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(adminApi.endpoints.getUsers.matchFulfilled, (state, { payload }) => {
			if (!payload) {
				return;
			}

			if (payload.data) {
				state.users = payload.data;
			}

			if (payload.meta) {
				state.meta = payload.meta;
			}
		});
		builder.addMatcher(
			adminApi.endpoints.updateUserLinkedinAllowed.matchFulfilled,
			(state, { payload }) => {
				if (!payload?.id) {
					return;
				}

				const userIndex = state.users.findIndex((user) => user.id === payload.id);

				if (userIndex !== -1) {
					state.users[userIndex].linkedinAllowed = payload.linkedinAllowed ?? false;
				}
			}
		);
		builder.addMatcher(adminApi.endpoints.getSendersUsers.matchFulfilled, (state, { payload }) => {
			if (payload?.data) {
				state.senders = payload.data;
			}
		});
	},
});

export const { setUsersSorting } = adminSlice.actions;
export const adminReducer = adminSlice.reducer;
export const adminSelector = (state: RootState) => state[adminSlice.name];
